import type { LiveState } from '../lib/live.ts';

/**
 * Connection state, always visible.
 *
 * Staff must never have to wonder whether a message actually sent. An
 * always-on counter screen that has silently stopped receiving looks
 * identical to a quiet morning, which is the failure this prevents.
 */
const LABEL: Record<LiveState, string> = {
  connecting: 'Connecting',
  open: 'Live',
  offline: 'Offline',
};

/**
 * A word, not a coloured dot.
 *
 * Red and green alone ask the reader to remember which is which, and
 * a counter PC is used by whoever is standing there. The state says
 * what it is; the colour only reinforces it.
 */
export const LiveDot = ({ state }: { readonly state: LiveState }) => (
  <span className={`liveTag live-${state}`} title={LABEL[state]}>
    <i />
    {LABEL[state]}
  </span>
);
